import { Box, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMutation } from '@parkchirp/api-client';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { UPDATE_NOTES_INVOICE_HISTORY } from '../../../queries';
import { SnackBarProps } from '../../../types';
import { isOwnerPortal } from '../../../utils';
import { EditorModal } from '../../modals';

interface EditNotesModalProps {
	rowId: string;
	handleClose: () => void;
	existingNotes: string | null;
	rowType: string;
	refetch: () => void;
	setShowSnackbar: Dispatch<SetStateAction<Partial<SnackBarProps> | null>>;
}

export const EditNotesModal = ({
	rowId,
	rowType,
	handleClose,
	existingNotes,
	refetch,
	setShowSnackbar,
}: EditNotesModalProps) => {
	const [notes, setNotes] = useState('');
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [updateNotes, { loading }] = useMutation(UPDATE_NOTES_INVOICE_HISTORY);

	useEffect(() => {
		if (existingNotes) setNotes(existingNotes);
	}, [existingNotes]);

	const theme = useTheme();

	return (
		<EditorModal
			theme={theme}
			handleClose={handleClose}
			handleSave={async () => {
				const response = await updateNotes({
					context: {
						apiVersion: 'v2',
					},
					variables: {
						referenceId: rowId,
						notes,
						type: rowType,
					},
				});
				if (!response?.data?.updateNotesInvoiceHistory) {
					setShowSnackbar({
						message: 'Failed to update notes',
						severity: 'error',
						autoHideDuration: null,
					});
					return;
				}
				refetch();
				handleClose();
			}}
			hasUnsavedChanges={hasUnsavedChanges}
			loading={loading}
			headerText='Transaction Notes'
			readOnly={isOwnerPortal}
		>
			<Box
				style={{
					minHeight: '300px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<TextField
					style={{ width: '100%' }}
					id='edit-notes-modal'
					label='Edit Notes'
					multiline
					rows={10}
					variant='filled'
					value={notes}
					onChange={(e) => {
						setHasUnsavedChanges(true);
						setNotes(e.target.value);
					}}
					disabled={isOwnerPortal}
				/>
			</Box>
		</EditorModal>
	);
};
